
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 74.083 74.083","height":"280","width":"280"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f5f5f5","d":"M34.057 1.852h5.638v70.38h-5.638z"}}),_c('path',{attrs:{"fill":"#f5f5f5","d":"M66.058 57.072L4.88 21.882l2.82-4.864 61.177 35.19z"}}),_c('path',{attrs:{"fill":"#f5f5f5","d":"M68.878 21.882L7.699 57.072 4.88 52.208l61.178-35.19z"}}),_c('path',{attrs:{"stroke-miterlimit":"10","fill":"none","stroke":"#f5f5f5","stroke-width":"4.23328","d":"M37.042 18.042L48.484 6.643M37.042 18.042L25.6 6.643M37.042 55.71l11.442 11.4M37.042 55.71L25.6 67.11M20.67 27.46L16.48 11.887M20.67 27.46L5.039 31.632M53.414 46.293l15.63-4.172M53.414 46.293l4.188 15.572M20.67 46.293L5.039 42.121M20.67 46.293L16.48 61.866M53.414 27.46l4.188-15.572M53.414 27.46l15.63 4.172"}})])
          )
        }
      }
    